export default "__VITE_ASSET__BDcgBGAd__"